/**
 * Get files from /resources/js/public-2026
 */
var req = require.context('./public-2026', true, /^(.*\.(js$))[^.]*$/im);
req.keys().forEach(function(key) {
    req(key);
});
